import { z } from "zod";
import { siteThemeConfigSchema } from "./theme";
import { navigationConfigSchema } from "./navigation";
import { homepageLayoutConfigSchema } from "./layout";

/**
 * Zod schema for SiteConfig.
 */
export const siteConfigSchema = z.object({
  id: z.string().min(1, "Site ID is required"),
  name: z.string().min(1, "Site name is required"),
  domain: z.string().min(1, "Domain is required"),
  theme: siteThemeConfigSchema,
  navigation: navigationConfigSchema,
  layout: homepageLayoutConfigSchema,
});
